/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-console */
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {
    Grid,
    Row,
    Column,
    Keyboard,
    Button,
    Heading,
    Form,
    FormInput,
    cls,
    HeaderCompound
} from 'packages/components';
import { connect } from 'react-redux';
import Translator from '../../../requests/apa/Translator';
import { autobind } from 'packages/core/lib';
import { PAYMENT_CVV } from '../../utils/constants';
import DeviceStorage from '../../../components/DeviceStorage/DeviceStorage';
import {
    showModal,
    AAF_MODAL_SUCCESS
} from '../../../actions/modal';
import Utils from '../../../utils/Utils';
import Assets from '../../../requests/apa/Asset';
import { apiPaywayConfirm, onPaymetSuccess, getWorkflow, showError, setInitialFocus, onFocusElement, handleTypeModal, filterInputValue, redirectPlayerOneClic, isModalHide } from '../../utils/Utils';
import UtilsPagos from "../../../utils/payway/UtilsPagos";
import Spinner from '../../../components/Spinner';
import Device from '../../../devices/device';
import {GA4} from 'src/utils/trackers/GA4';
import {PAYMENT_METHOD_CREDIT_CARD} from 'src/utils/trackers/GA4Constants';
import UtilsClaroPagos from '../utils';
import './_styles.scss';

interface ICardProps {
    pbi: any;
    worflowstart: any;
    selectedPaymentMethod: string;
    type: number;
    history: any;
}
interface ICardState {
    form: {
        image_card: string;
        cvv: string;
    };
    errorFromBackend: string;
    showTooltipSuccess: boolean;
    wfs: any;
    isLoading: boolean;
    card_type: string;
}

class ConfirmationCVV extends Component<RouteComponentProps & ICardProps, ICardState> {
    public titleForm: string = Translator.get('claropagosgate_confirmCvv_title_label', 'Confirma tu compra');
    public textNext: string = Translator.get('claropagosgate_confirmCvv_option_button_next', 'Siguiente');
    public textCancel: string = Translator.get('claropagosgate_confirmCvv_option_button_cancel', 'Cancel');
    private isValidForm: boolean;
    public keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
    private from: string = '';

    constructor(props: RouteComponentProps & ICardProps) {
        super(props);
        const { location: { state = {} } = {} } = props || {};
        this.from = state?.from;
        this.state = {
            form: {
                image_card: '',
                cvv: ''
            },
            errorFromBackend: '',
            showTooltipSuccess: false,
            wfs: {},
            isLoading: false,
            card_type: '0'
        };
    }

    public componentDidMount() {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('keydown', this.onKeyPress, true);
        const { worflowstart, selectedPaymentMethod } = this.props;
        const { form } = this.state;
        const wfs = getWorkflow(selectedPaymentMethod, worflowstart);
        let asset: string = '';
        let { card_type } = this.state
        if (wfs && wfs.paymentMethodData && wfs.paymentMethodData.cardsData.length > 0) {
            card_type = wfs.paymentMethodData.cardsData[0].card_type
            const assetName = `claropagosgate_number_icon_${card_type === '1' ? 'visa' : 'mastercard'}`;
            asset = Assets.get(assetName);
        }
        this.setState({ wfs, card_type, form: { ...form, image_card: asset } });
        if (isModalHide()) {
            setInitialFocus('.aaf_form-group-input-element .aaf_focusable', false);
        }
    }

    public componentWillUnmount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
    }

    @autobind
    private handleChange(value: string, type: string): void {
        const { form } = this.state;
        let { errorFromBackend } = this.state;
        this.isValidForm = value !== '';
        if (value === '' || value !== '') {
            errorFromBackend = '';
        }
        const filteredValue = filterInputValue(value, type);
        this.setState({ form: { ...form, [type]: filteredValue }, errorFromBackend } as ICardState);
    }

    @autobind
    private sendGA4Metric() {
        const gA4 = new GA4();
        gA4.sendAddPaymentMethodEvent(PAYMENT_METHOD_CREDIT_CARD);
    }

    @autobind
    private updateCard() {
        const { form: { cvv }, wfs } = this.state;
        const action = 'update_card';

        const client = {
            default: true,
            client_id: wfs.paymentMethodData.account,
            cvv2: cvv
        };

        const config = UtilsClaroPagos.getConfiguration(action);
        const authorization = Utils.Base64Decode(config.header.authorization);
        const server_url = config.server_url.replace('{token}', wfs.paymentMethodData.cardsData[0].token);
        return new Promise((resolve, reject) => {
            UtilsClaroPagos.generalRequest(server_url, client, authorization, 'PUT').then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error);
            });
        });
    }

    private handleSubmit = (): void => {
        const { pbi, pbi: { isSubscription }, selectedPaymentMethod } = this.props;
        const { form: { cvv }, wfs } = this.state;
        let cb = isSubscription ? (resp: object) => this.redirectAddon(resp) : (resp: object) => this.redirectVCard(resp);
        const fingerprint = DeviceStorage.getItem("HKS") + new Date().toTimeString().split(' ')[0];
        try {
            Utils.scriptCyberSource();
        } catch (e) {
            console.error('Error al cargar script CyberSource', e.message)
        }
        if (cvv.length <= 2) {
            this.setState({ errorFromBackend: Translator.get('form_tooltip_empty_label_validation', 'Debes completar este campo para continuar.') });
        }
        if (cvv.length >= 3 && fingerprint) {
            this.setState({ isLoading: true });
            const formParams = {
                card_type: wfs.paymentMethodData.cardsData[0].card_type,
                client_id: '',
                device_fingerprint: fingerprint,
                card_token: ''
            }
            this.sendGA4Metric();
            this.updateCard().then((response: any) => {
                const { data: { tarjeta: { token, cliente_id } } } = response;
                formParams.client_id = cliente_id;
                formParams.card_token = token;
                apiPaywayConfirm({ pbi, wfs, formParams: formParams })
                .then((resp) => {
                    onPaymetSuccess(resp, pbi, wfs, selectedPaymentMethod, cb);
                    this.setState({ isLoading: false });
                })
                .catch(err => {
                    showError(err);
                    this.setState({ isLoading: false });
                });
            }).catch((error) => {
                console.error('[Error update card]', error);
            });
        }
    };

    @autobind
    private showTicket(resp: any, groupId: string, islive: boolean) {
        const { showModal } = this.props;
        const { type, worflowstart: { contentInfo }, pbi, pbi: { producttype, currency, price, family, periodicity, frequency }, selectedPaymentMethod } = this.props;
        const region = DeviceStorage.getItem('region');
        const { response: { end_date: { day = '', month = '', year = '' } = {}, payway_token = '' } = {} } = resp || {};
        const payDate = `${day} ${month} ${year}`;

        const data = {
            pbi,
            total: UtilsPagos.getTotalAndPeriodicity(currency, price, periodicity),
            duration: `${Translator.get(periodicity, '')}`,
            frequency: frequency,
            days: Translator.get(`bonus_${producttype}`),
            content: Translator.get(`Ticket_Transaccion_TextoDescripcion_${producttype}`, ''),
            payment_method: Translator.get(`ticket_subscription_${selectedPaymentMethod}_label`, ''),
            img_largeSub: Assets.get(`${region}_transactional_${family}_poster`, ''),
            img_large: contentInfo?.contentImageMedium,
            providerImage: Assets.get(`transactional_${family}_logo`),
            title: contentInfo?.contentTitle || '',
            type: type,
            from: this.from
        };

        const modal = {
            modalType: AAF_MODAL_SUCCESS,
            modalProps: {
                data: handleTypeModal({ ...data, next_pay: payDate }),
                handlePlay: () => this.from ? this.handleAddOn(resp) : this.handlePlay(groupId, payway_token, islive),
                handleVCard: () => this.handleVCard(groupId)
            }
        };
        showModal(modal);
    }

    private redirectAddon(resp: any): void {
        const { pbi: { groupId = '', oneoffertype = '', islive = false } } = this.props;
        const { worflowstart: { selectedPaymentMethod } } = this.props;
        const isOneClicFlow = groupId === '' ? false : true;
        const oneClicKey = `${oneoffertype}_${selectedPaymentMethod}`;
        if (UtilsPagos.oneClicBuyHiddeConfirm(isOneClicFlow, oneClicKey)) {
            if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
                const { response: { payway_token = '' } = {} } = resp || {};
                this.handlePlay(groupId, payway_token, islive);
            }
            else {
                // este caso aplica cuando no se tiene activado el one clic muestra modal de compra exitosa
                this.showTicket(resp, groupId, islive);
            }
        } else {
            // aplica para plan selector y vcard cuando no hay one clic
            this.showTicket(resp, groupId, islive);
        }
    }

    private redirectVCard(resp?: any): void {
        const { pbi: { groupId = '', oneoffertype = '', islive = false }, worflowstart: { selectedPaymentMethod } } = this.props;
        const isOneClicFlow = groupId === '' ? false : true;
        const oneClicKey = `${oneoffertype}_${selectedPaymentMethod}`;
        if (UtilsPagos.oneClicBuyHiddeConfirm(isOneClicFlow, oneClicKey)) {
            if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
                setTimeout(() => {
                    const { history } = this.props;
                    const nav = Utils.getApaMetadataKey('links_nav_configuration', Utils.mock_links_nav_configuration());
                    if (islive) {
                        if(nav && nav.home) {
                            history.replace(`/node/${nav.home}`);
                        }
                    }
                    else if (groupId) {
                        this.handleVCard(groupId);
                    }
                }, 0);
            }
            else {
                // este caso aplica cuando no se tiene activado el one clic muestra modal de compra exitosa
                this.showTicket(resp, groupId, islive);
            }
        } else {
            // aplica para plan selector y vcard cuando no hay one clic
            this.showTicket(resp, groupId, islive);
        }
    }

    private handleAddOn(resp: any) {
        const { history, nodes } = this.props;
        const { response: { node_id = '' } = {} } = resp || {};
        let nodeString: string = '';
        const filterNodes = nodes.filter((value: any) => value.code === 'playandgo');
        const resultChilds = filterNodes.map((res: any) => {
            const childsValue = res.childs;
            return childsValue;
        });

        for (let index = 0; index < resultChilds.length; index++) {
            const element = resultChilds[index];
            element.map((resId: any) => {
                if (resId.id === node_id) {
                    return nodeString = resId.code;
                }
            });
        }

        this.setState({ isLoading: false });
        history.replace(`/node/${nodeString ? nodeString : 'homeuser'}`);
    }

    @autobind
    private handlePlay(groupId: string, payway_token: string, islive: boolean) {
        if (groupId) {
            redirectPlayerOneClic(groupId, islive, payway_token, () => {
                this.handleVCard(groupId);
            })
        }
    }

    @autobind
    private handleVCard(groupId: string) {
        if (groupId) {
            const { history } = this.props;
            history.replace(`/vcard/${groupId}`);
        }
    }

    private hadleCancel = (): void => {
        const { history } = this.props;
        history.goBack();
    };

    @autobind
    private handleBack(): void {
        const { history } = this.props;
        history.goBack();
    }

    @autobind
    private onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (currentKey === 'YELLOW') {
            this.handleBack();
        }
    }

    @autobind
    private onFocus(): void {
        onFocusElement([{ id: 'cvv' }]);
    }

    public render(): JSX.Element {
        const {
            wfs,
            isLoading,
            form: { image_card },
            errorFromBackend
        } = this.state;
        if (isLoading) return <Spinner className={cls(`${PAYMENT_CVV}-spinner`)} loadingMessage='' />;
        return (
            <Grid className={Device.getDevice().getPlatform()}>
                <HeaderCompound
                    disabled
                    align='right'
                    onClick={this.handleBack}
                    textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                    icon={`${Assets.get('top_head_option_back')}`}
                    onFocus={this.onFocus}
                />
                <Row>
                    <Form id="payment-card-form">
                        <Column lg={6} className={cls(`${PAYMENT_CVV}-column-keyboard`)}>
                            <Keyboard id="Keyboard" onFocus={this.onFocus} filteredFuncion={filterInputValue} />
                        </Column>
                        <Column lg={6} className={cls(`${PAYMENT_CVV}-column-inputs`)}>
                            <Row className={cls(`${PAYMENT_CVV}-row-inputs`)}>
                                <Column lg={12}>
                                    <Heading size={1} className={cls(`${PAYMENT_CVV}-title-form`)}>
                                        {this.titleForm}
                                    </Heading>
                                </Column>
                                <Column lg={12}>
                                    <img className={`${PAYMENT_CVV}-card-type`} src={image_card} alt='card_type' />
                                    <span className={`${PAYMENT_CVV}-card-pan`}>{wfs.paymentMethodData?.cardsData ? wfs.paymentMethodData?.cardsData[0]?.pan : ''}</span>
                                </Column>
                                <Row className={cls(`${PAYMENT_CVV}-column-input`)}>
                                    <Column lg={8}>
                                        <span className={`${PAYMENT_CVV}-codigo`}>{Translator.get('claropagosgate_confirmCvv_description_label', 'Ingresa el código de seguridad de tu tarjeta*')}</span>
                                    </Column>
                                    <Column lg={4}>
                                        <FormInput
                                            focusWhenMount
                                            id='cvv'
                                            type="numeric"
                                            name="cvv"
                                            placeholder={Translator.get('claropagosgate_confirmCvv_placeHolder_textfield', 'CVV')}
                                            onChange={(e) => this.handleChange(e, 'cvv')}
                                            errorFromBackend={errorFromBackend}
                                            maxLength={4}
                                        />
                                    </Column>
                                </Row>
                                <Column lg={12}>
                                    <p className={`${PAYMENT_CVV}-obligatorio`}>{Translator.get('claropagosgate_confirmCvv_descriptionRequired_label', '*Estos campos son obligatorios')}</p>
                                </Column>
                                <Column lg={12}>
                                    <Button
                                        activate
                                        type="button"
                                        variant="primary"
                                        disabled={!this.isValidForm}
                                        className={cls(`focusable`, `${PAYMENT_CVV}-button-next`)}
                                        onClick={this.handleSubmit}
                                        block
                                        onFocus={this.onFocus}
                                    >
                                        {this.textNext}
                                    </Button>
                                </Column>
                                <Column lg={12} className={cls(`${PAYMENT_CVV}-column-next`)}>
                                    <Button
                                        activate
                                        type="button"
                                        className={cls(
                                            `focusable`,
                                            `${PAYMENT_CVV}-button-cancel`
                                        )}
                                        onClick={this.hadleCancel}
                                        block
                                        onFocus={this.onFocus}
                                    >
                                        {this.textCancel}
                                    </Button>
                                </Column>
                                <Column lg={12} className={`${PAYMENT_CVV}-seguro`}>
                                    <img src={Assets.get('claropagosgate_confirmCvv_security_icon')} />
                                    <span className={`${PAYMENT_CVV}-ss`}> {Translator.get('claropagosgate_confirmCvv_descriptionSecurity_label', 'Servico seguro')}</span>
                                </Column>
                            </Row>
                        </Column>
                    </Form>
                </Row>
            </Grid>
        );
    }
}

const mapDispatchToProps = {
    showModal,
};

export default connect(null, mapDispatchToProps)(ConfirmationCVV);



// WEBPACK FOOTER //
// ./src/payments/ClaroPagosGate/ConfirmationCVV/index.tsx